module.exports = __webpack_public_path__ + "img/ljdk_zhTc.07386212.png";